function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { textsDefaul, ENVIRONMENT_FLOW, ACCESS_TYPE_FLOW } from '@/js/constants';
import utils from '@/js/utils';
import SearchTableau from '@/components/SearchTableau';
import PaginationTableau from '@/components/PaginationTableau';
import PaginationVue from '@/components/PaginationVue.vue';
import FormMetaReportDatastudio from '@/modules/tasks/datastudio/components/FormMetaReportDatastudio';
import DatastudioReportService from '@/apps/data-platform/services/visualization/datastudio_report_service';
import FilesService from '@/apps/data-platform/services/security/files_service';
import DialogsComponent from '@/components/DialogsComponent.vue';
import StateComponent from '@/components/StateComponent.vue';
import tasks from '@/js/tasks';
import FormAssignTemporalOwner from '@/components/FormAssignTemporalOwner.vue';
export default {
  name: 'ContMyReportsGdsComponent',
  components: {
    SearchTableau: SearchTableau,
    PaginationTableau: PaginationTableau,
    FormMetaReportDatastudio: FormMetaReportDatastudio,
    PaginationVue: PaginationVue,
    DialogsComponent: DialogsComponent,
    StateComponent: StateComponent,
    FormAssignTemporalOwner: FormAssignTemporalOwner
  },
  data: function data() {
    return {
      collapse_filter: false,
      isBusy: false,
      messageLoading: textsDefaul.LOADING,
      messageEmptyList: textsDefaul.NOT_REPORTS,
      defaultDomain2: null,
      gds_report: [],
      data_list: [],
      messageEmptyGDSDs: textsDefaul.LOADING,
      title_modal: '',
      data_ds: null,
      path_name: '',
      limit: 4,
      pageDs: 1,
      totalRowsDs: 0,
      isReadonly: false,
      MODAL_NAME_OWNER: 'ContReportMeOwnerGDS',
      MODAL_NAME_ALL_OWNER: 'ContReportsMeOwnerAllGDS',
      MODAL_NAME_REPORT: 'modalchangeMetaReportGDS' + this.type,
      ACCESS_TYPE_FLOW: ACCESS_TYPE_FLOW,
      pagination: {
        total: 0,
        limit: 4,
        offset: 1,
        current: 1
      },
      filter: '',
      select_domain: ''
    };
  },
  props: {
    showDomains: {
      type: Boolean,
      required: false,
      default: true
    },
    type: {
      type: String,
      required: true,
      default: 'sm'
    },
    filterEnabled: {
      type: Boolean
    }
  },
  beforeMount: function beforeMount() {},
  computed: {
    reportFields: function reportFields() {
      return [
      // { key: '↕', variant: 'return-sort', class: 'w-3' },
      {
        text: 'Report',
        value: 'object_name',
        sortable: true,
        class: 'text-left w-30'
      }, {
        text: this.traductor('my_objects.tablas_objects.environment'),
        value: 'environment',
        class: 'w-10',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.pages'),
        value: 'pages.length',
        class: 'w-7',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.datasource'),
        value: 'datasources.length',
        class: 'w-10',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.creation_date'),
        value: 'creation_time',
        class: 'w-15',
        sortable: true,
        align: 'center'
      }, {
        text: this.traductor('my_objects.tablas_objects.actions'),
        value: 'actions',
        class: 'text-left w-15',
        align: 'left'
      }, {
        text: this.traductor('my_objects.tablas_objects.rol'),
        value: 'rol',
        class: 'w-10',
        align: 'center'
      }];
    },
    isEmptyWorkDs: function isEmptyWorkDs() {
      return !(this.gds_report && this.gds_report.length);
    },
    composeName: function composeName() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        var text = '';
        if (item) {
          text = "".concat(item.path_name, "/").concat(item.object_name).replace(/\//g, '&nbsp;/&nbsp;');
        }
        return text;
      };
    },
    isDataOperator: function isDataOperator() {
      return function () {
        var item = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
        return item.data_operator === window.userInfo.email;
      };
    },
    showAssignDataOperator: function showAssignDataOperator() {
      return function (item) {
        // return item.owner_email === window.userInfo.email && item.environment === ENVIRONMENT_FLOW.PROD
        return item.environment === ENVIRONMENT_FLOW.PROD;
      };
    },
    hideAssignAllTables: function hideAssignAllTables() {
      var _this = this;
      return function () {
        var list_env = [];
        var data = {};
        if (_this.gds_report && _this.gds_report.length) {
          var _iterator = _createForOfIteratorHelper(_this.gds_report),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var table = _step.value;
              data = {
                env: table.environment,
                operator: table.data_operator
              };
              list_env.push(data);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        }
        return list_env.some(function (item) {
          return item.env === 'prod' && item.operator === window.userInfo.email;
        });
      };
    }
  },
  created: function created() {
    if (window.userInfo.isSignIn) {
      window.userInfo.isSignIn = false;
      setTimeout(function () {
        location.reload();
      }, 1000);
    }
    this.select_domain = window.userInfo.domain;
    if (window.userInfo.isSignIn === undefined) {
      this.reloadGDSReport();
    }
  },
  methods: {
    openLookerReport: function openLookerReport(item) {
      console.log('open looker report', item);
      var url = "https://lookerstudio.google.com/u/1/reporting/".concat(item.report_id, "/");

      // Abre el reporte de Looker Studio en una nueva pestaña
      window.open(url, '_blank');
    },
    onSearch: function onSearch(filter) {
      this.filter = filter.text_filter;
      if (this.select_domain != filter.choose_domain) {
        this.select_domain = filter.choose_domain;
        this.reloadGDSReport();
      }
    },
    onCleanSearch: function onCleanSearch() {
      this.filter = '';
      this.select_domain = window.userInfo.domain;
      this.reloadGDSReport();
    },
    traductor: function traductor(key) {
      return this.$i18n.t(key);
    },
    onSearchQueryReport: function onSearchQueryReport(data) {
      // this.reloadGDSReport(data)
      this.pagination.current = 1;
      if (data.clauses) {
        console.log(data, this.data_list);
        if (data.clauses.query_type == 'advanced') {
          var search = data.clauses.query.toUpperCase();
          this.gds_report = this.data_list.filter(function (x) {
            return x.environment.toUpperCase().indexOf(search) != -1 || x.object_name.toUpperCase().indexOf(search) != -1;
          });
        } else {
          this.gds_report = Object.assign([], this.data_list);
          if (data.clauses.object_name) {
            this.gds_report = this.gds_report.filter(function (x) {
              return x.object_name.toUpperCase().indexOf(data.clauses.object_name.toUpperCase()) != -1;
            });
          }
          if (data.clauses.environment) {
            this.gds_report = this.gds_report.filter(function (x) {
              return x.environment.toUpperCase().indexOf(data.clauses.environment.toUpperCase()) != -1;
            });
          }
        }
      } else {
        this.gds_report = Object.assign([], this.data_list);
      }
      this.pagination.total = this.gds_report.length;
    },
    processParams: function processParams(params) {
      return _objectSpread({
        domain: window.userInfo.domain,
        limit: this.limit,
        page: this.pageDs,
        filters: [{
          key: 'data_operator',
          operator: '==',
          value: window.userInfo.email
        }]
      }, params);
    },
    reloadGDSReport: function reloadGDSReport(params) {
      var _this2 = this;
      this.gds_report = [];
      this.pagination.total = 0;
      var defaultParams = this.processParams(params);
      this.isBusy = true;
      DatastudioReportService.myObjects(defaultParams).then(function (res) {
        if (res && res.code === 200) {
          _this2.gds_report = res.data;
          _this2.data_list = Object.assign([], res.data);
          _this2.pagination.total = _this2.gds_report.length;
          _this2.pageDs = 1;
          _this2.messageEmptyGDSDs = res.data.length === 0 ? textsDefaul.NOT_REPORTS : null;
          _this2.loadPreviews();
        } else if (res && res.code === 400) {
          console.info(res);
        }
      }).catch(function (e) {
        utils.printError(e);
      }).finally(function () {
        _this2.isBusy = false;
      });
    },
    loadPreviews: function loadPreviews() {
      var _this3 = this;
      this.gds_report.forEach(function (element) {
        if (element.preview_image) {
          FilesService.readFile(element.preview_image).then(function (response) {
            _this3.$set(element, 'report_image', response.data.base64);
          });
        }
      });
    },
    changeMetaReport: function changeMetaReport(item) {
      var _this4 = this;
      var readonly = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      DatastudioReportService.getReportById({
        report_id: item.report_id
      }).then(function (res) {
        console.log('open report');
        _this4.title_modal = "REPORT: ".concat(res.data.object_name);
        _this4.data_ds = utils.cloneJSON(res.data);
        _this4.path_name = res.data.path_name;
        _this4.isReadonly = readonly;
        // this.$bvModal.show(this.MODAL_NAME_REPORT)
        _this4.$refs[_this4.MODAL_NAME_REPORT].onOpen();
      });
    },
    onCloseModalReport: function onCloseModalReport() {
      // this.$bvModal.hide(this.MODAL_NAME_REPORT)
      this.$refs[this.MODAL_NAME_REPORT].onClose();
    },
    onPageReport: function onPageReport(page) {
      this.pageDs = page;
      this.reloadTableauReport({
        page: page
      });
    },
    openAllTempOwner: function openAllTempOwner() {
      if (!this.hideAssignAllTables()) {
        tasks.toast.error('No tiene Reportes para asignar.');
        return;
      }
      // this.$bvModal.show(this.MODAL_NAME_ALL_OWNER)
      this.$refs[this.MODAL_NAME_ALL_OWNER].onOpen();
      return true;
    },
    openTempOwner: function openTempOwner(item) {
      this.data_ds = item;
      // this.$bvModal.show(this.MODAL_NAME_OWNER)
      this.$refs[this.MODAL_NAME_OWNER].onOpen();
      return true;
    },
    assignOwner: function assignOwner() {
      this.reloadGDSReport();
      // this.$bvModal.hide(this.MODAL_NAME_OWNER)
      this.$refs[this.MODAL_NAME_OWNER].onClose();
      return true;
    },
    assignAllOwner: function assignAllOwner() {
      this.reloadGDSReport();
      // this.$bvModal.hide(this.MODAL_NAME_ALL_OWNER)
      this.$refs[this.MODAL_NAME_ALL_OWNER].onClose();
      return true;
    },
    onShowReport: function onShowReport(item) {
      var _this5 = this;
      var data = {
        'domain': item.domain_org
      };
      DatastudioReportService.generateToken(data).then(function (response) {
        console.log(response);
        var paramsAsString = JSON.stringify(response.data.params);
        var paramsEncoded = encodeURIComponent(paramsAsString);
        _this5.$emit('onShowReport', "".concat(item.access_link, "?params=").concat(paramsEncoded));
      });
    },
    onCloseReport: function onCloseReport() {
      this.url_report = '';
      this.show_report = false;
    },
    onOpenPopoverOpenBI: function onOpenPopoverOpenBI(item) {
      var _iterator2 = _createForOfIteratorHelper(this.gds_dataset.filter(function (r) {
          return r.report_id !== item.report_id;
        })),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var record = _step2.value;
          this.$root.$emit('bv::hide::popover', "'popover-open-pbi-' + ".concat(record.report_id));
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    },
    onClosePopoverOpenBI: function onClosePopoverOpenBI(item) {
      this.$root.$emit('bv::hide::popover', "'popover-open-pbi-' + ".concat(item.report_id));
    },
    copyAccessLink: function copyAccessLink(link) {
      navigator.clipboard.writeText(link);
      this.$toast.info('Access link copied!');
    },
    handleScroll: function handleScroll() {
      console.log('scrolltable');
    },
    openReport: function openReport(item) {
      this.$router.push({
        name: 'GDSReportViewer',
        params: {
          id: item.report_id
        }
      });
    },
    changePagina: function changePagina() {}
  }
};